import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'eview-post-comment-list',
  templateUrl: 'post-comment-list.component.html',
  styleUrls: ['post-comment-list.component.scss']
})
export class PostCommentListComponent implements OnInit {
  @Input() public commentList;
  @Input() private viewOnlyMode;
  @Output() public onDeleteClick: EventEmitter<any> = new EventEmitter();
  constructor() { }
  count: number = 5;
  ngOnInit() {
  }

}
